/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface PhrasalVerbSearchParams extends PageQueryParams {
  search?: string
}

export interface PhrasalVerbApiParams {
  page: number
  limit: number
  search?: string
}

export const phrasalVerbService = {
  list(params: PhrasalVerbApiParams) {
    return HttpRequest.get("v1/phrasal-verbs", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  detail(id: number) {
    return HttpRequest.get(`v1/phrasal-verbs/${id}`).json<Response>()
  },
}
